import getLocale from "./getLocale";
import bus from "./bus.js";
import { addKeywords } from "./keywords.js";

export function getSurveyQuestions() {
    // Get a copy of latest Questionnaire text
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4) {
        if(this.status===200){
            let survey = JSON.parse(this.responseText)
            for(const step in survey.Steps){
                for(const question in survey.Steps[step].Questions){
                    survey.Steps[step].Questions[question].Text=addKeywords(survey.Steps[step].Questions[question].Text);
                    for(const subquestion in survey.Steps[step].Questions[question].SubQuestions){
                        survey.Steps[step].Questions[question].SubQuestions[subquestion].Text=addKeywords(survey.Steps[step].Questions[question].SubQuestions[subquestion].Text);
                    }
                }
            } 
            bus.$emit("setSurvey", survey);
        }
      }
    };
    xhttp.open("GET", "/"+getLocale(true)+"/api/survey/AZGACA2017", true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
